export default __webpack_public_path__ + "static/media/wholesalecart_yellow.9757aec6.svg";